
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chuyen-gia-bac-si/[[...params]]",
      function () {
        return require("private-next-pages/chuyen-gia-bac-si/[[...params]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chuyen-gia-bac-si/[[...params]]"])
      });
    }
  